import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-solvaig-instruction',
  imports: [CommonModule],
  templateUrl: './solvaig-instruction.component.html',
  styleUrl: './solvaig-instruction.component.scss',
})
export class SolvaigInstructionComponent {
  public hide: boolean = true;
}
